import React, {useContext, useMemo} from "react";
import {Context} from "../../index";

export function PaneMenu() {
  const {
    paneMenu,
    user: {hasCustomStore}
  } = useContext(Context);

  return useMemo(
    () =>
      paneMenu.map((item) => {
        const {label, url} = item;

        if (
          item.hasOwnProperty(`hasCustomStore`) &&
          hasCustomStore !== item.hasCustomStore
        ) {
          return;
        }

        return (
          <li key={label + url}>
            <a href={url}>{label}</a>
          </li>
        );
      }),
    [hasCustomStore, paneMenu]
  );
}
